import { render, staticRenderFns } from "./Type6Block.vue?vue&type=template&id=5a33f7fa&scoped=true&"
import script from "./Type6Block.vue?vue&type=script&lang=js&"
export * from "./Type6Block.vue?vue&type=script&lang=js&"
import style0 from "./Type6Block.vue?vue&type=style&index=0&id=5a33f7fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33f7fa",
  null
  
)

export default component.exports